import React from 'react';

function NoMatch() {
  return (
    <div className="flex min-h-[100vh] items-center justify-center bg-black">
      <h2 className="font-Proxima text-h-lg uppercase text-white">Sorry!</h2>
    </div>
  );
}

export default NoMatch;
